'use client'

import * as React from 'react'
import { Check, Minus } from 'lucide-react'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'

import { cn } from '@/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & { iconClassName?: string }
>(({ className, iconClassName, checked, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    checked={checked}
    className={cn(
      'peer border-foreground/35 data-[state=checked]:border-emphasis data-[state=checked]:bg-emphasis data-[state=checked]:text-emphasis-foreground data-[state=indeterminate]:border-emphasis data-[state=indeterminate]:bg-emphasis data-[state=indeterminate]:text-emphasis-foreground hover:border-foreground/60 grid h-4 w-4 shrink-0 place-content-center rounded-none border bg-transparent transition-[color,background-color,border-color,scale] duration-150 disabled:cursor-not-allowed disabled:opacity-50 motion-safe:active:scale-90',
      className
    )}
    {...props}
  >
    {/* The tick pops in as the box fills (the indicator only mounts while checked). */}
    <CheckboxPrimitive.Indicator className="animate-in zoom-in-50 fade-in-0 grid place-content-center text-current duration-150 ease-out motion-reduce:animate-none">
      {checked === 'indeterminate' ? (
        <Minus className={cn('size-3 text-current', iconClassName)} />
      ) : (
        <Check className={cn('size-3 text-current', iconClassName)} />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

/**
 * Filter/column list rows (FilterRow, ColumnsTab) use the base look: hairline square,
 * solid foreground with a background-colored tick when checked, in both themes. Kept as
 * named exports so those lists keep one hook for list-specific tweaks.
 */
export const FILTER_CHECKBOX_CLASS = ''

export const FILTER_CHECKBOX_ICON_CLASS = ''

export { Checkbox }
